export default __webpack_public_path__ + "static/beatport-23e3cdb0bc4f26a08a5be70bc09ed23a.png";